/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NodataDiscardAdditionalServiceItem
 */
export interface NodataDiscardAdditionalServiceItem {
    /**
     * 附加服务ID
     * @type {number}
     * @memberof NodataDiscardAdditionalServiceItem
     */
    additionalServiceId: number;
    /**
     * 金额
     * @type {number}
     * @memberof NodataDiscardAdditionalServiceItem
     */
    amount: number;
    /**
     * 货币代码，默认 KRW
     * @type {string}
     * @memberof NodataDiscardAdditionalServiceItem
     */
    currencyCode?: string;
}

/**
 * Check if a given object implements the NodataDiscardAdditionalServiceItem interface.
 */
export function instanceOfNodataDiscardAdditionalServiceItem(value: object): value is NodataDiscardAdditionalServiceItem {
    if (!('additionalServiceId' in value) || value['additionalServiceId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function NodataDiscardAdditionalServiceItemFromJSON(json: any): NodataDiscardAdditionalServiceItem {
    return NodataDiscardAdditionalServiceItemFromJSONTyped(json, false);
}

export function NodataDiscardAdditionalServiceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataDiscardAdditionalServiceItem {
    if (json == null) {
        return json;
    }
    return {
        
        'additionalServiceId': json['additionalServiceId'],
        'amount': json['amount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
    };
}

export function NodataDiscardAdditionalServiceItemToJSON(json: any): NodataDiscardAdditionalServiceItem {
    return NodataDiscardAdditionalServiceItemToJSONTyped(json, false);
}

export function NodataDiscardAdditionalServiceItemToJSONTyped(value?: NodataDiscardAdditionalServiceItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'additionalServiceId': value['additionalServiceId'],
        'amount': value['amount'],
        'currencyCode': value['currencyCode'],
    };
}

